import { render, staticRenderFns } from "./buy-cursos.vue?vue&type=template&id=676f8425&scoped=true"
import script from "./buy-cursos.vue?vue&type=script&lang=js"
export * from "./buy-cursos.vue?vue&type=script&lang=js"
import style0 from "./buy-cursos.vue?vue&type=style&index=0&id=676f8425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f8425",
  null
  
)

export default component.exports